
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/components/ui/use-toast';
import { removeStoredUser } from './userStorage';
import * as Sentry from "@sentry/react";

/**
 * Perform user logout
 */
export const performLogout = async (): Promise<void> => {
  // Add logout attempt breadcrumb
  Sentry.addBreadcrumb({
    category: 'auth',
    message: 'Logout attempt',
    level: 'info',
  });
  
  try {
    // Call Supabase auth API
    const { error } = await supabase.auth.signOut();
    
    if (error) {
      console.error("Error during signOut:", error);
      Sentry.captureException(error, {
        tags: { action: 'logout' },
      });
      throw error;
    }
    
    console.log("Supabase signOut successful");
    
    // Add successful logout breadcrumb
    Sentry.addBreadcrumb({
      category: 'auth',
      message: 'Logout successful',
      level: 'info',
    });
  } catch (error) {
    console.error("Exception during logout:", error);
    Sentry.captureException(error, {
      tags: { action: 'logout' },
    });
  } finally {
    // Always remove user from localStorage regardless of API success
    removeStoredUser();
    
    // Clear Supabase session data from localStorage without using projectRef
    // Find and remove all Supabase-related items in localStorage
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('sb-')) {
        console.log(`Removing Supabase item from localStorage: ${key}`);
        localStorage.removeItem(key);
      }
    });
    
    // Clear user from Sentry context
    Sentry.setUser(null);
    
    toast({
      title: "Logged Out",
      description: "You have been successfully logged out.",
    });
  }
};
